module.exports = __webpack_public_path__ + "img/logo_vuejs.ef449066.png";